import { z } from "zod";

const taxItemSchema = z.object({
  name: z.string().min(1, "Tax name is required"),
  percentage: z.number().min(0, "Percentage must be non-negative").max(100, "Percentage cannot exceed 100"),
});

const lineItemSchema = z.object({
  description: z.string().min(1, "Description is required"),
  quantity: z.number().min(1, "Quantity must be at least 1"),
  unitPrice: z.number().min(0, "Unit price must be positive"),
});

export const formSchema = z.object({
  invoiceNumber: z.string().min(1, "Invoice number is required"),
  issueDate: z.date({
    required_error: "Issue date is required",
  }),
  dueDate: z.date({
    required_error: "Due date is required",
  }),
  businessName: z.string().min(1, "Business name is required"),
  businessTaxId: z.string().min(1, "Tax ID is required"),
  businessIban: z.string().min(1, "IBAN is required"),
  businessSwift: z.string().min(1, "SWIFT/BIC is required"),
  businessEmail: z.string().email("Invalid email address"),
  businessPhone: z.string().min(1, "Phone number is required"),
  recipientName: z.string().min(1, "Client name is required"),
  recipientEmail: z.string().email("Invalid email format"),
  recipientAddress: z.string().min(1, "Address is required"),
  clientTaxId: z.string().min(1, "Client tax ID is required"),
  clientPhone: z.string().min(1, "Client phone is required"),
  lineItems: z.array(lineItemSchema).min(1, "At least one line item is required"),
  taxes: z.array(taxItemSchema).default([{ name: "IVA", percentage: 23 }]),
  bankAccountHolder: z.string().min(1, "Account holder name is required"),
  bankIban: z.string().min(1, "Bank IBAN is required"),
  bankName: z.string().min(1, "Bank name is required"),
  bankSwift: z.string().min(1, "Bank SWIFT/BIC is required"),
  paymentReference: z.string().min(1, "Payment reference is required"),
  recipients_emails: z.array(z.string()), // Changed to array of strings
  currency: z.enum(["EUR", "GBP", "USD"]).default("EUR"),
});

export type FormData = z.infer<typeof formSchema>;
export type LineItem = z.infer<typeof lineItemSchema>;
export type TaxItem = z.infer<typeof taxItemSchema>;
